import { useState, useRef } from "react";

import { styled } from "styled-components";

import { useClickAway, useEscapePress, Tooltip } from "../../components";
import { UiTooltipModel } from "../../models";
import { colorCSS } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export type UiTooltipProps = {
    readonly model: UiTooltipModel;
};

const UiTooltip = ({ model }: UiTooltipProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLButtonElement | null>(null);
    const { triggerText, tooltipText } = model.content;

    useEscapePress(() => setIsOpen(false));
    useClickAway(ref, () => setIsOpen(false));

    return (
        <>
            <Trigger
                ref={ref}
                onClick={() => setIsOpen(true)}
                data-testid="ui-tooltip-trigger"
            >
                {triggerText}
            </Trigger>
            <Tooltip
                document={tooltipText}
                modalId={model.id}
                isOpen={isOpen}
                parentRef={ref}
            />
        </>
    );
};

const Trigger = styled.button`
    ${redundantCssFromKebab("appearance", "none")}
    ${redundantCssFromKebab("background-color", "transparent")}
    ${redundantCssFromKebab("border", "none")}
    ${redundantCssFromKebab("border-bottom", `2px dotted ${colorCSS("N60")}`)}
    ${redundantCssFromKebab("border-radius", "3px")}
    ${redundantCssFromKebab("color", `${colorCSS("N900")}`)}
    ${redundantCssFromKebab("padding", "0")}
    &:hover {
        ${redundantCssFromKebab(
            "border-bottom",
            `2px dotted ${colorCSS("N100")}`
        )}
    }
    &:focus {
        ${redundantCssFromKebab("outline", "none")}
    }
`;

export default UiTooltip;
